import React from 'react';

const ButtonWithIcon = ({
  children,
  onClick,
  className = "",
  disabled = false,
  type = "button",
  iconLeft: IconLeft,
  iconRight: IconRight,
  iconLeftClassName = "icon-left",
  iconRightClassName = "icon-right",
  href,
  target,
  rel,
  variant = "default",
  forceState,
  ...props
}) => {
  const baseClasses = "btn";
  const variantClass = variant ? `btn--${variant}` : "";
  const stateClass = forceState ? `is-${forceState}` : "";
  const combinedClasses = [baseClasses, variantClass, stateClass, className]
    .filter(Boolean)
    .join(" ");

  const buttonContent = (
    <>
      {IconLeft && <IconLeft className={iconLeftClassName} />}
      {children && <span className="text">{children}</span>}
      {IconRight && <IconRight className={iconRightClassName} />}
    </>
  );

  // If href is provided, render as anchor tag
  if (href) {
    return (
      <a
        href={href}
        className={combinedClasses}
        onClick={onClick}
        target={target}
        rel={rel}
        aria-disabled={disabled}
        data-force-state={forceState || undefined}
        {...props}
      >
        {buttonContent}
      </a>
    );
  }

  // Otherwise render as button
  return (
    <button
      type={type}
      className={combinedClasses}
      onClick={onClick}
      disabled={disabled}
      data-force-state={forceState || undefined}
      {...props}
    >
      {buttonContent}
    </button>
  );
};

export default ButtonWithIcon;
